<div class="container my-3">
  <!-- <h1 class="mb-3">Edit Plant</h1> -->
  <form #form="ngForm" (ngSubmit)="updateplant()" class="mt-4">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Type</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="plantDetails.Type"
          name="Type"
        >
          <option
            *ngFor="let type of types"
            [value]="type.Id"
            [selected]="type.Id === plantDetails.Type"
          >
            {{ type.TypeName }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Company</label>
      </div>
      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="plantDetails.CompanyId"
          name="companyId"
        >
          <option
            *ngFor="let company of companys"
            [value]="company.Id"
            [selected]="company.Id === plantDetails.CompanyId"
          >
            {{ company.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Region</label>
      </div>

      <div class="col-sm-4">
        <select
          class="form-select border border-dark"
          [(ngModel)]="plantDetails.Region"
          name="Region"
          required
        >
          <option
            *ngFor="let region of regions"
            [value]="region.Name"
            [selected]="region.Name === plantDetails.Region"
          >
            {{ region.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Location</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="location"
          name="location"
          [(ngModel)]="plantDetails.Location"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="name"
          name="name"
          [(ngModel)]="plantDetails.Name"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Description</label>
      </div>
      <div class="col-sm-4">
        <textarea
          type="text"
          class="form-control border border-dark"
          id="description"
          name="description"
          [(ngModel)]="plantDetails.Description"
        ></textarea>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Thumbnail</label>
      </div>
      <div class="col-sm-4">
        <div class="col-sm-4">
          <input
            type="file"
            class="form-control-file"
            id="thumbnail"
            (change)="addFile(input.files, 1)"
            name="thumbnail"
            [(ngModel)]="plantDetails.Thumbnail"
            #input
            required
          />
        </div>
        <div [hidden]="!showthumbnail">
          <span
            (click)="viewFile(plantDetails.Id, plantDetails.Thumbnail)"
            style="color: blue; cursor: pointer"
            ><u>{{ plantDetails.Thumbnail }}</u></span
          >
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Attachments</label>
      </div>
      <div class="col-sm-4">
        <div class="col-sm-4">
          <input
            type="file"
            class="form-control-file"
            ngf-select
            ng-Model="new_files"
            (change)="addFile(input1.files, 2)"
            id="attachments"
            name="attachments"
            [(ngModel)]="plantDetails.Attachments"
            #input1
            required
          />
        </div>
        <div [hidden]="!showattachment">
          <span
            (click)="viewFile2(plantDetails.Id, plantDetails.Attachments)"
            style="color: blue; cursor: pointer"
            ><u>{{ plantDetails.Attachments }}</u></span
          >
        </div>
      </div>
    </div>

    <div style="min-height: 100px"></div>
    <div class="row">
      <div class="col-sm-2" style="text-align: right">
        <button type="submit" class="btn custom-buttons-btn">Update</button>
      </div>

      <div class="col-sm-2" style="text-align: left">
        <button
          type="button"
          class="btn custom-delete-btn"
          (click)="deletePlant(plantDetails.Id)"
        >
          Delete
        </button>
      </div>
    </div>
  </form>
</div>
